import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  gridContainer: {
    padding: theme.spacing(3),
  },
}));

export default useStyles;
